export const STAGE_LABELS = {
  invited: "Invited",
  screening: "Screening",
  video: "Video",
  coding: "Coding",
  scorecard: "Scorecard",
  incomplete: "Incomplete",
  shortlist: "Completed",
  rejected: "Rejected",
};

export const stageLabel = (s) => STAGE_LABELS[s] || (s ? s[0].toUpperCase() + s.slice(1) : "");
